import { React, useRef, useEffect } from 'react';
// @vendors
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// @styles 
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './styles.scss'
import { Fade } from 'react-reveal';

gsap.registerPlugin(ScrollTrigger);

export default function SliderHome({ data }) {
    const info = data.primary
    const items = data.items
    const refSlider = useRef();

    useEffect(() => {
        const ctx = gsap.context(() => {
            const isSmall = window.matchMedia("(max-width: 575px)").matches;
            const isBig = window.matchMedia("(min-width: 1713px)").matches;
            const space = window.matchMedia("(min-width: 1024px)").matches ? 350 : 0;
            const windowSize = refSlider.current.offsetWidth;
            const panels = gsap.utils.toArray(".slide");
            const quantity = panels.length;
            const factor = (document.getElementById('slide').offsetWidth + (isBig || isSmall ? 48 : 0)) + space;
            const value = quantity - (windowSize / factor);
            gsap.to(panels, {
                xPercent: (quantity == 3 ? -113 * value : -108 * value),
                ease: "none",
                scrollTrigger: {
                    trigger: refSlider.current,
                    pin: true,
                    scrub: true,
                    snap: 1 / (quantity - 1),
                    end: () => "+=" + windowSize
                }
            });
        }, refSlider);
        return () => ctx.revert();
    });

    document.querySelectorAll("img").forEach(img => {
        if (img.complete) {
            ScrollTrigger.refresh();
        } else {
            img.addEventListener('load', imgLoaded => ScrollTrigger.refresh());
        }
    });

    return (
        <>
            <div className='slider__container' id={info.idcontent} ref={refSlider}>
                <div className='slider__container-content'>
                    {info.sectiontitle && (
                        <Fade left delay={0.3}>
                            <div className='homepage__container-title center-title'>
                                <p>{info.sectiontitle ? info.sectiontitle : ""}</p>
                            </div>
                        </Fade>
                    )}
                </div>

                <div className="slide-track">
                    {items && items.length > 0 && items.map((item, index) => (
                        <div className='slide' key={index} id='slide'>
                            <div className='slide-item'>
                                <img src={item.image ? item.image.url : ""} alt={item?.image?.alt} className='slide-item-img' />
                                <p className='slide-item-description'>{item.message ? item.message : ""}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}